"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDataAttributes = useDataAttributes;
var _react = require("react");
function dataAttributesFrom(props) {
  var dataAttributes = {};
  for (var _key in props) {
    if (_key.startsWith('data-')) {
      dataAttributes[_key] = props[_key];
    }
  }
  return dataAttributes;
}
function useDataAttributes(props) {
  return (0, _react.useMemo)(function () {
    return dataAttributesFrom(props);
  }, [props]);
}